// extracted by mini-css-extract-plugin
export default {"wrap":"AdaptiveLogo_wrap__Jl5UL"};